<template>
    <div class="flex gap-2">
        <div class="grow"/>
        <div class="flex items-center gap-1">
            <UButton
                icon="i-ph-download"
                data-cy="document-preview-download-button"
                variant="subtle"
                color="neutral"
                @click="$emit('onClickDownload')"
            >
                <span class="font-semibold" :data-cy="`document-preview-filename-${documentMeta.uuid}`">{{ documentMeta.filename }}</span>
            </UButton>
        </div>
    </div>
    <div class="h-full flex flex-col items-center justify-start gap-2 pt-2">
        <object
            v-if="!isXml"
            ref="objectFrame"
            class="grow object-contain bg-gray-400 overflow-auto w-full h-full"
            :data="documentMeta.url"
            :type="documentMeta.contentType"
            ondrop="return false"
        />
        <pre
            v-else
            class="font-mono text-sm w-full h-full overflow-auto whitespace-pre-wrap break-all p-4 bg-gray-50 text-gray-800"
        >
            {{ ehfXml }}
        </pre>
    </div>
</template>

<script setup lang="ts">
import {EnrichedDocument} from '@/types/transaction/DocumentMeta'
import {computed, onMounted, ref} from 'vue'
import axios from 'axios'

const props = defineProps({
    documentMeta: {
        type: Object as () => EnrichedDocument,
        required: true
    }
})

defineEmits<{ (e: 'onClickDownload'): Promise<void> }>()

const isXml = computed(() => props.documentMeta.contentType.includes('xml'))
const ehfXml = ref('')

onMounted(async () => {
    if (isXml.value) {
        const response = await axios.get(props.documentMeta.url)
        ehfXml.value = await response?.data
    }
})
</script>

<style scoped>

</style>